import React, { FC } from 'react';
import { ReactComponent as Fns1 } from 'assets/img/taxStatus/ФНС.svg';
import { ReactComponent as Fns2 } from 'assets/img/taxStatus/fns2.svg';
import { ReactComponent as Fns3 } from 'assets/img/taxStatus/error.svg';
import { ReactComponent as CrossIcon } from 'assets/img/iconCross.svg';
import styles from './InfoEmployedItem.module.scss';
import { getFormatPhone } from 'utils/getFotmatPhone';
import classNames from 'classnames';
import { AppTooltip } from 'ui/AppTooltip';
import { TextWithTooltip } from 'hooks/TextWithTooltip';
import { Avatar } from 'components/Avatar';

interface InfoEmployedItemTypes {
  fns_status?: number;
  fio: string;
  inn: string;
  phone?: string;
  phoneStatus?: null | number;
  chooseHandler?: () => void;
  workerAppStatus?: number;
  orders?: boolean;
  style?: React.CSSProperties;
  taxe?: boolean;
  deleteEmployedHandler?: () => void;
  isDelete?: boolean;
  workSupport?: boolean;
  worker_id?: number;
  worker_app_id?: number;
}

export const InfoEmployedItem: FC<InfoEmployedItemTypes> = ({
  fns_status = 0,
  fio,
  inn,
  phone,
  chooseHandler,
  orders,
  style,
  taxe,
  deleteEmployedHandler,
  isDelete,
  workSupport,
  worker_id,
  worker_app_id,
}) => {
  const fnsIcon = fns_status === 2 ? <Fns1 /> : fns_status === 1 ? <Fns2 /> : <Fns3 />;
  const fnsLabel =
    fns_status === 1
      ? 'Привязан к платформе без права оплаты налога'
      : 'Не привязан к платформе';

  return (
    <div
      style={style}
      onClick={chooseHandler}
      className={classNames(styles.root, !taxe && styles.root_hover)}>
      <div className={styles.content}>
        {isDelete ? (
          <div className={styles.deletedAvatar}>
            <Avatar
              isDeleted={true}
              name={fio}
              surname={fio}
              avatar={''}
              statusActive={''}
              id={worker_id}
            />
          </div>
        ) : (
          <AppTooltip
            label={fnsLabel}
            position='bottom'
            offset={8}
            arrowPosition='center'>
            <div className={styles.fnsIcon}>{fnsIcon}</div>
          </AppTooltip>
        )}

        <div className={styles.root_info}>
          <div className={styles.root_info_main}>
            <div className={styles.root_info_fio}>
              <TextWithTooltip content={fio || ''} className={styles.root_name} />
            </div>
          </div>
          {inn && <p className={styles.root_info_inn}>{`ИНН ${inn}`}</p>}
          {!orders && (
            <>
              <div className={styles.root_info_phone}>
                <p>Телефон {phone ? getFormatPhone(phone) : ''}</p>
              </div>
              <div className={styles.root_info_phone}>
                <p>worker_id {worker_id}</p>
              </div>
              <div className={styles.root_info_phone}>
                <p>worker_app_id {worker_app_id}</p>
              </div>
            </>
          )}
        </div>
      </div>
      {isDelete && workSupport && (
        <div onClick={deleteEmployedHandler} className={styles.choose_icon}>
          <CrossIcon />
        </div>
      )}
    </div>
  );
};
